import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "readOnly", "linkConfig", "buttonConfig"];
import React, { memo } from 'react';
export var withCellClickingWrapper = function withCellClickingWrapper(WrappedComponent) {
  return /*#__PURE__*/memo(function (_ref) {
    var disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      linkConfig = _ref.linkConfig,
      buttonConfig = _ref.buttonConfig,
      props = _objectWithoutProperties(_ref, _excluded);
    var handleClick = function handleClick(event) {
      if ((disabled || readOnly) && linkConfig !== null && linkConfig !== void 0 && linkConfig.href) {
        event.preventDefault();
      }
      if (linkConfig && linkConfig !== null && linkConfig !== void 0 && linkConfig.onClick && !(disabled || readOnly)) {
        linkConfig.onClick({
          event: event,
          id: linkConfig === null || linkConfig === void 0 ? void 0 : linkConfig.id
        });
      }
      if (buttonConfig) {
        buttonConfig.onClick({
          event: event,
          id: buttonConfig.id
        });
      }
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      buttonConfig: buttonConfig,
      disabled: disabled,
      linkConfig: linkConfig,
      onClick: handleClick,
      readOnly: readOnly,
      "data-t-id": "Cell-hocs"
    }));
  });
};